import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router'

import Card from 'react-bootstrap/cjs/Card'
import { Link } from 'react-router-dom'

import { _, api } from 'utils'
import { CreateJobOpeningRequest } from 'types/swagger'
import { ParamSlug } from 'types'
import Icon from 'components/Icon'

import { showErrorNotification } from '../../notifications/notificationsSlice'
import JobForm from './JobForm'

const S = {
    Card: styled(Card)`
        padding: 12px;
    `,
    Page: styled.div`
        padding: 24px;
    `,
    Header: styled.div`
        display: flex;
        margin-bottom: 40px;
    `,
    Title: styled.h1`
        font-weight: 500;
        font-size: 20px;
    `,
}

const AddJob = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { eventSlug, boothSlug } = useParams() as ParamSlug

    const save = async (data: CreateJobOpeningRequest) => {
        const url = `/events/${eventSlug}/organizer/booths/${boothSlug}/jobs/`
        const reponse = await api.safePost(url, data)
        if (reponse.error) {
            dispatch(showErrorNotification(reponse.error))
        } else {
            history.push('jobs')
        }
    }

    return (
        <S.Page>
            <S.Header>
                <Link to="jobs">
                    <Icon icon="previous" />
                </Link>
                <S.Title>{_('booth.jobs.new.page_title')}</S.Title>
            </S.Header>
            <S.Card>
                <Card.Body>
                    <JobForm save={save} />
                </Card.Body>
            </S.Card>
        </S.Page>
    )
}
export default AddJob
